export const isBannerShow = (plan, user) => {
    return (plan?.plan?.name === 'free_trial') || (plan?.plan?.name === 'professional_trial') ||
        (plan?.plan?.name === 'professional' && plan?.expiration_date && user?.chargebee_customer_id !== "-");
}